<template>
  <div class="ma-4">
    <v-snackbar
      v-model="msg"
      top
      :color="snackbarColor"
      :timeout="3000"
      elevation="4"
      class="rounded-lg"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{
          snackbarColor === "success" ? "mdi-check-circle" : "mdi-alert"
        }}</v-icon>
        {{ text }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="msg = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-card class="rounded-lg">
      <v-app-bar flat dense color="grey lighten-4" class="rounded-t-lg px-3">
        <v-btn icon small class="mr-2 grey lighten-3" @click="$router.go(-1)">
          <v-icon>navigate_before</v-icon>
        </v-btn>

        <span class="text-h6 font-weight-medium grey--text text--darken-3">
          Bulk Attendance
        </span>

        <v-spacer></v-spacer>
      </v-app-bar>

      <v-divider></v-divider>

      <v-card-text class="pa-6 grey lighten-5">
        <v-row dense>
          <v-col cols="12" md="6">
            <service-code
              v-model="serviceCode"
              v-on:change-service-code="serviceCode = $event"
              outlined
              dense
              hide-details
              class="rounded-lg"
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              label="Client Status"
              :items="clientStatuses"
              v-model="reportFilters.clientStatus"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-select
              :label="isLoading ? 'Loading...' : 'Select Clients'"
              :items="filteredClients"
              item-value="ClientID"
              :item-text="item => item.clientInfo?.Name"
              v-model="clientList"
              multiple
              prepend-icon="person"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
            />
          </v-col>

          <v-col cols="12" md="6" v-if="requiredTime">
            <v-select
              v-model="timeStart"
              label="Time Start"
              prepend-icon="mdi-clock-time-four-outline"
              :items="times"
              item-text="Time"
              item-value="Value"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" v-if="requiredTime">
            <v-select
              v-model="timeEnd"
              label="Time End"
              prepend-icon="mdi-clock-time-four-outline"
              @change="calcUnits"
              :items="times"
              item-text="Time"
              item-value="Value"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  hide-details
                  class="rounded-lg"
                  background-color="white"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                scrollable
                multiple
                color="primary"
                class="rounded-lg"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              label="Units"
              v-model="units"
              prepend-icon="add"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-checkbox
              label="Signature"
              v-model="signed"
              @click="addSignature"
              class="rounded-lg"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" v-if="signed">
            <v-text-field
              v-model='signature'
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-btn
              color="primary"
              large
              class="rounded-lg"
              :disabled="!canAddAttendance"
              :loading="isLoading"
              elevation="1"
              @click="addAttendance()"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Attendance
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import {STATUS_ARRAY} from '../../enums/UserStatusEnum';
import ServiceCode from '@/components/commons/ServiceCode.vue';
import moment from 'moment'
import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../../client_config/config").url;


export default {
  mixins: [
    ReportFilters,
  ],
  components: {
    ServiceCode
  },
  data: () => ({
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    startDate: [],
    clients: [],
    clientList: [],
    serviceCode: {},
    serviceUnit: '',
    units: '',
    signed: false,
    signature: '',
    startTime: '',
    endTime: '',
    rate: '',
    userState: localStorage.getItem('userState'),
    userID: localStorage.getItem('userID'),
    staff: localStorage.getItem('Name'),
    msg: false,
    text: '',
    isLoading: false,
    canAddAttendance: false,
    clientStatuses: STATUS_ARRAY,
    requiredTime: false,
    times: [
      {Time: "6:00am", Value: "6:00am"}, {Time: "6:15am", Value: "6:15am"}, {
        Time: "6:30am",
        Value: "6:30am"
      }, {Time: "6:45am", Value: "6:45am"},
      {Time: "7:00am", Value: "7:00am"}, {Time: "7:15am", Value: "7:15am"}, {
        Time: "7:30am",
        Value: "7:30am"
      }, {Time: "7:45am", Value: "7:45am"},
      {Time: "8:00am", Value: "8:00am"}, {Time: "8:15am", Value: "8:15am"}, {
        Time: "8:30am",
        Value: "8:30am"
      }, {Time: "8:45am", Value: "8:45am"},
      {Time: "9:00am", Value: "9:00am"}, {Time: "9:15am", Value: "9:15am"}, {
        Time: "9:30am",
        Value: "9:30am"
      }, {Time: "9:45am", Value: "9:45am"},
      {Time: "10:00am", Value: "10:00am"}, {Time: "10:15am", Value: "10:15am"}, {
        Time: "10:30am",
        Value: "10:30am"
      }, {Time: "10:45am", Value: "10:45am"},
      {Time: "11:00am", Value: "11:00am"}, {Time: "11:15am", Value: "11:15am"}, {
        Time: "11:30am",
        Value: "11:30am"
      }, {Time: "11:45am", Value: "11:45am"},
      {Time: "12:00pm", Value: "12:00pm"}, {Time: "12:15pm", Value: "12:15pm"}, {
        Time: "12:30pm",
        Value: "12:30pm"
      }, {Time: "12:45pm", Value: "12:45pm"},
      {Time: "1:00pm", Value: "13:00pm"}, {Time: "1:15pm", Value: "13:15pm"}, {
        Time: "1:30pm",
        Value: "13:30pm"
      }, {Time: "1:45pm", Value: "13:45pm"},
      {Time: "2:00pm", Value: "14:00pm"}, {Time: "2:15pm", Value: "14:15pm"}, {
        Time: "2:30pm",
        Value: "14:30pm"
      }, {Time: "2:45pm", Value: "14:45pm"},
      {Time: "3:00pm", Value: "15:00pm"}, {Time: "3:15pm", Value: "15:15pm"}, {
        Time: "3:30pm",
        Value: "15:30pm"
      }, {Time: "3:45pm", Value: "15:45pm"},
      {Time: "4:00pm", Value: "16:00pm"}, {Time: "4:15pm", Value: "16:15pm"}, {
        Time: "4:30pm",
        Value: "16:30pm"
      }, {Time: "4:45pm", Value: "16:45pm"},
      {Time: "5:00pm", Value: "17:00pm"}, {Time: "5:15pm", Value: "17:15pm"}, {
        Time: "5:30pm",
        Value: "17:30pm"
      }, {Time: "5:45pm", Value: "17:45pm"},
      {Time: "6:00pm", Value: "18:00pm"}, {Time: "6:15pm", Value: "18:15pm"}, {
        Time: "6:30pm",
        Value: "18:30pm"
      }, {Time: "6:45pm", Value: "18:45pm"},
      {Time: "7:00pm", Value: "19:00pm"}, {Time: "7:15pm", Value: "19:15pm"}, {
        Time: "7:30pm",
        Value: "19:30pm"
      }, {Time: "7:45pm", Value: "19:45pm"},
      {Time: "8:00pm", Value: "20:00pm"}, {Time: "8:15pm", Value: "20:15pm"}, {
        Time: "8:30pm",
        Value: "20:30pm"
      }, {Time: "8:45pm", Value: "20:45pm"},
      {Time: "9:00pm", Value: "21:00pm"}, {Time: "9:15pm", Value: "21:15pm"}, {
        Time: "9:30pm",
        Value: "21:30pm"
      }, {Time: "9:45pm", Value: "21:45pm"},
      {Time: "10:00pm", Value: "22:00pm"}, {Time: "10:15pm", Value: "22:15pm"}, {
        Time: "10:30pm",
        Value: "22:30pm"
      }, {Time: "10:45pm", Value: "22:45pm"},
      {Time: "11:00pm", Value: "23:00pm"}, {Time: "11:15pm", Value: "23:15pm"}, {
        Time: "11:30pm",
        Value: "23:30pm"
      }, {Time: "11:45pm", Value: "23:45pm"},
    ],
    timeStart: "",
    timeEnd: "",
    reportFilters: {
      ServiceCode: '',
      clientStatus: '',
      ClientID: '',
      startDate: '',
      endDate: '',
    },
    reportFilterName: 'ReportFilters_BulkAttendance',
    snackbarColor: "success",
  }),

  computed: {
    filteredClients() {
      let clients = this.clients;

      const clientStatus = this.reportFilters.clientStatus;
      if (clientStatus !== "" && clientStatus) {
        clients = clients.filter(client => client.clientInfo?.Status === clientStatus);
      }

      return clients;
    }
  },

  watch: {
    serviceCode: {
      handler(newVal, oldVal) {
        this.units = '';
        if (newVal !== oldVal) this.getClients();
        switch (newVal.Unit) {
          case "Quarter Hour":
          case "Session":
          case "Hourly":
            this.requiredTime = true;
            break;

          case "Daily":
          default:
            this.requiredTime = false;
            break;
        }
        this.reportFilters.ServiceCode = newVal;
      }
    },

    clientList: {
      handler() {
        this.checkCanAdd();
      }
    },

    startDate: {
      handler() {
        this.checkCanAdd();
      }
    },

    reportFilters: {
      handler(newVal) {
        this.setReportFilters(this.reportFilterName, newVal);
      },
      deep: true
    }
  },

  created() {
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    this.serviceCode = this.reportFilters.ServiceCode;
  },

  methods: {

    checkCanAdd() {
      this.canAddAttendance = this.serviceCode && this.clientList.length > 0 && this.startDate.length > 0;
    },

    getClients() {
      this.isLoading = true;
      this.clients = [];

      if (!this.serviceCode) {
        return;
      }

      // Parse company IDs from localStorage
      let companyIds = [];
      try {
        companyIds = JSON.parse(localStorage.getItem('userCompanies')) || [];
      } catch (err) {
        console.error('Invalid userCompanies in localStorage:', err);
      }

      const endpoint = `${url}/serviceCodes/${this.serviceCode.Code}/clients`;

      axios.get(endpoint, {
        params: {
          Company: companyIds
        }
      })
        .then((res) => {
          this.clients = res.data.clients;
        })
        .catch(error => {
          console.error('Error fetching clients:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addAttendance() {
      for (var i = 0; i < this.clientList.length; i++) {
        for (var d = 0; d < this.startDate.length; d++) {
          var req_body = {
            Code: this.serviceCode.Code,
            Date: this.startDate[d],
            Signature: this.signature,
            ClientID: this.clientList[i],
            Units: this.units,
            ServiceUnit: this.serviceCode.Unit,
            TimeStart: this.timeStart,
            TimeEnd: this.timeEnd,
            Rate: this.Rate,
          }
          axios.post(`${url}/attendance`, req_body).then(res => {
            this.msg = true;
            this.text = res.data.msg;
            this.clear()
          })
        }
      }
    },

    clear() {
      this.clientList = [];
      this.clients = [];
      this.serviceCode = '';
      this.units = '';
      this.signature = '';
      this.signed = false;
      this.startDate = [];
      this.isLoading = false;
    },

    addSignature: function () {
      this.signed = true;
      this.signature = this.staff + " - " + new Date();
    },

    calcUnits() {
      let timeDiff = moment.duration(moment.utc(moment(this.timeEnd, "HH:mm").diff(moment(this.timeStart, "HH:mm"))).format("HH:mm")).asMinutes();
      if (this.serviceCode.Unit == 'Quarter Hour') {
        this.units = parseInt(timeDiff) / 15
      } else if (this.serviceCode.Unit == 'Session') {
        this.units = parseInt(timeDiff) / 30
      } else if (this.serviceCode.Unit == 'Hourly') {
        this.units = parseInt(timeDiff) / 60
      } else {
        this.units = 1
      }
      this.calcForError();

    },

    calcForError() {
      if (moment(this.timeStart, 'hh:mma').isAfter(moment(this.timeEnd, 'hh:mma')) ||
        moment(this.timeStart, 'hh:mma').isSame(moment(this.timeEnd, 'hh:mma'))) {

        this.msg = true;
        this.text = 'Please make sure the end time is after the start time';
        this.units = 0
      }
    },
  }
}
</script>

<style scoped>
.v-data-table {
  border: 1px solid #e0e0e0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0;
}

.v-text-field ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.v-select ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.rounded-lg {
  border-radius: 8px !important;
}

.rounded-t-lg {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}
</style>
